export default {
      id: "studio-usage",
      viewBox: "0 0 34 28",
      url: __webpack_public_path__ + "img/icons.f759dcb6.svg#studio",
      toString: function () {
        return this.url;
      }
    }